import { errorToastMessage, successToastMessage } from "utils/errorToast";
import { LOADER_STATUS, EMAIL_MASTER_DATA } from "./constants";
import { getLocalStorage } from "components/Helper/Helper.js";
import { Config } from "../../../Config.js";
import axios from "axios";

export const loader = (status) => {
  return {
    type: LOADER_STATUS,
    loaderStatus: status,
  };
};

export function setEmailMasterData(data) {
  return {
    type: EMAIL_MASTER_DATA,
    emailMasterData: data,
  };
}

export const getEmailMasterData = () => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    try {
      const response = await axios({
        method: "get",
        url: `${Config.url}notices/email-master`,
        headers: {
          "Content-Type": "application/json",
          token,
        },
        timeout: 60000,
      });

      if (response.data.status === "success" && response.data.statusCode === 200) {
        dispatch(setEmailMasterData(response.data.data || []));
        console.log("Email Master Data:", response.data.data);
        return true;
      } else {
        console.log("API Error:", response.data);
        errorToastMessage(response.data.message || "Failed to fetch email configurations");
        dispatch(setEmailMasterData([]));
        return false;
      }
    } catch (error) {
      console.log("Error fetching email master data:", error);
      errorToastMessage("Error while fetching email configurations");
      dispatch(setEmailMasterData([]));
      return false;
    } finally {
      dispatch(loader(false));
    }
  };
};

export const addEmailMasterData = (gstin, email) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}notices/email-master`,
        headers: {
          "Content-Type": "application/json",
          token,
        },
        data: {
          gstin,
          email,
        },
        timeout: 60000,
        validateStatus: function (status) {
          return status >= 200 && status < 500; // Resolve only if the status code is less than 500
        }
      });

      if (response.data.status === "success" && response.data.statusCode === 200) {
        console.log("Email Master Add Success:", response.data.data);
        successToastMessage(response.data.message || "Email configuration created successfully");
        return { success: true, data: response.data.data };
      } else {
        console.log("API Error:", response.data);
        errorToastMessage(response.data.message || "Failed to create email configuration");
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      console.log("Error adding email master data:", error);
      console.log("error.AxiosError:",error.code)
      console.log("Request config:", error.config);
      
      // Handle specific error cases
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        if (errorData.statusCode === 409) {
          errorToastMessage(errorData.message || "Email configuration already exists for this GSTIN");
        } else if (errorData.statusCode === 400) {
          errorToastMessage(errorData.message || "Invalid input data");
        } else {
          errorToastMessage(errorData.message || "Error while creating email configuration");
        }
        return { success: false, message: errorData.message };
      } else {
        errorToastMessage("Network error while creating email configuration");
        return { success: false, message: "Network error" };
      }
    } finally {
      dispatch(loader(false));
    }
  };
};
